module.exports = __webpack_public_path__ + "assets/img/59b4d17e4dae61f0d15c42b338f4bec2.svg";